const styleKeyMapping = {
    banner: 'childBannerStyle',
    bannerCallout: 'childCalloutStyle',
    bannerLogo: 'childLogoStyle',
    bannerTag: 'childTagStyle',
    bannerTitle: 'childTitleStyle',
    swTitle: 'titleStyle',
    bannerDescription: 'childDescriptionStyle',
    swDescription: 'descriptionStyle',
    bannerTextArea: 'childTextAreaStyle',
    footerButton: 'footerButtonStyle',
    clposition: 'positionindicatorStyle',
    position_indicator: 'positionIndicatorFlag',
    swSpacing: 'spacingStyle',
    highlight: 'highlightStyle',
    rating: 'ratingStyle',
    priceUnit: 'priceUnitStyle',
    message: 'messageStyle',
    cta: 'ctaStyle',
    productTag: 'productTagStyle',
    sticker: 'stickerStyle',
    shadeSize: 'shadeSizeStyle',
    brandProduct: 'brandProductStyle',
    cardProperties: 'cardPropertiesStyle',
    unitArea: 'unitAreaStyle',
    unitTag: 'unitTagStyle',
    imageArea: 'imageAreaStyle',
    imageCallout: 'imageCalloutStyle',
    unitTitle: 'unitTitleStyle',
    unitDescription: 'unitDescriptionStyle',
    separatorStyle: 'separatorStyle',
    trailingIconStyle: 'trailingIconStyle',
};
const IMAGE_STATIC_URL = 'https://www.nykaa.com/media/wysiwyg';
const iconsKeyMapping = {
    arrow: '/2022/core/arrow-right.svg',
    chevron_down: '/2022/core/chevron-down-small.svg',
    chevron_right: '/2022/core/chevron-right-small.svg',
    alert: '/2022/core/alert-info.svg',
    more: '/2022/core/more-vertical.svg',
};
export default {
    styleKeyMapping,
    iconsKeyMapping,
    IMAGE_STATIC_URL,
};
